import React from 'react';
import {useDispatch} from 'react-redux';

import {ROUTE} from 'containers/App/constants';
import WisbitList from 'containers/ManageWisbitPage/WisbitList';

import {Loading} from 'components';

import SubHeader from './SubHeader';
import i18n from 'i18next';
import {push} from 'connected-react-router';
import {useLoadWisbit} from 'containers/ManageWisbitPage/hooks';

function Wisbit() {
  const dispatch = useDispatch();

  const {data, loading} = useLoadWisbit(dispatch);

  return (
    <>
      <SubHeader
        title={i18n.t('dashboardPage.wisbits.title')}
        linkTo={ROUTE.Wisbit.Index}
        onClick={() => dispatch(push(ROUTE.Wisbit.Template))}
      />
      {loading ? (
        <Loading className="h-full-36" />
      ) : (
        <WisbitList data={data} className="h-full-36" />
      )}
    </>
  );
}

export default Wisbit;
